{
  "REPORT": {
    "HEADER": "Συζητήσεις",
    "LOADING_CHART": "Φόρτωση δεδομένων γραφήματος...",
    "NO_ENOUGH_DATA": "Δεν έχουν ληφθεί αρκετά σημεία δεδομένων για την δημιουργία της αναφοράς, Παρακαλώ προσπαθήστε αργότερα.",
    "DOWNLOAD_AGENT_REPORTS": "Κατέβασμα αναφορών πράκτορα",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Συζητήσεις",
        "DESC": "(Σύνολο)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Εισερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Εξερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Χρόνος πρώτης ανταπόκρισης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο πρώτος χρόνος απόκρισης είναι {metricValue} (βάσει {conversationCount} συνομιλίων)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Χρόνος ανάλυσης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο Χρόνος Ανάλυσης είναι {metricValue} (βασίζεται στις {conversationCount} συνομιλίες)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Αριθμός Αναλύσεων",
        "DESC": "(Σύνολο)"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Αριθμός Αναλύσεων",
        "DESC": "(Σύνολο)"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "(Σύνολο)"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Σήμερα",
      "YESTERDAY": "Χθες",
      "LAST_7_DAYS": "Τελευταίες 7 ημέρες",
      "LAST_30_DAYS": "Τελευταίες 30 ημέρες",
      "THIS_MONTH": "Αυτόν τον μήνα",
      "LAST_MONTH": "Τον προηγούμενο μήνα",
      "LAST_3_MONTHS": "Τελευταίοι 3 μήνες",
      "LAST_6_MONTHS": "Τελευταίοι 6 μήνες",
      "LAST_YEAR": "Τελευταίο έτος",
      "CUSTOM_DATE_RANGE": "Προσαρμοσμένο εύρος ημερομηνιών"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Εφαρμογή",
      "PLACEHOLDER": "Επιλέξτε εύρος ημερομηνιών"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Ομαδοποίηση Κατά",
    "DURATION_FILTER_LABEL": "Διάρκεια",
    "GROUPING_OPTIONS": {
      "DAY": "Ημέρα",
      "WEEK": "Εβδομάδα",
      "MONTH": "Μήνα",
      "YEAR": "Έτος"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Ημέρα"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Ημέρα"
      },
      {
        "id": 2,
        "groupBy": "Εβδομάδα"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Ημέρα"
      },
      {
        "id": 2,
        "groupBy": "Εβδομάδα"
      },
      {
        "id": 3,
        "groupBy": "Μήνα"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Ημέρα"
      },
      {
        "id": 2,
        "groupBy": "Εβδομάδα"
      },
      {
        "id": 3,
        "groupBy": "Μήνα"
      }
    ],
    "BUSINESS_HOURS": "Ώρες Εργασίας",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Δεν βρέθηκαν αποτελέσματα"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Συζητήσεις: {count}",
      "RESULT_COUNT_MESSAGE": "Μηνύματα: {count}",
      "EMPTY": "Δεν βρέθηκαν εγγραφές για αυτή τη στήλη.",
      "ERROR": "Δεν ήταν δυνατή η φόρτωση των εγγραφών. Δοκιμάστε ξανά.",
      "LOAD_MORE": "Φόρτωση περισσότερων",
      "PREVIOUS_BUCKET": "Προηγούμενη στήλη",
      "NEXT_BUCKET": "Επόμενη στήλη",
      "UNKNOWN_CONTACT": "Άγνωστη επαφή",
      "UNKNOWN_INBOX": "Άγνωστα εισερχόμενα",
      "UNASSIGNED_AGENT": "Χωρίς ανάθεση",
      "NO_MESSAGE_CONTENT": "Χωρίς περιεχόμενο μηνύματος",
      "MESSAGE_CREATED_AT": "Το μήνυμα δημιουργήθηκε στις {time}",
      "EVENT_OCCURRED_AT": "Το συμβάν έγινε στις {time}",
      "INCOMING_MESSAGE": "Εισερχόμενο μήνυμα",
      "OUTGOING_MESSAGE": "Εξερχόμενο μήνυμα",
      "VIEW_ALL": "Προβολή στις συζητήσεις",
      "VIEW_ALL_LIMIT": "Μόνο στήλες με έως {limit} συζητήσεις ανοίγουν στη λίστα συζητήσεων.",
      "HIDDEN_COUNT": "Δεν εμφανίζονται επειδή δεν είστε μέλος των εισερχομένων τους: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Επισκόπηση Πρακτόρων",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Φόρτωση δεδομένων γραφήματος...",
    "NO_ENOUGH_DATA": "Δεν έχουν ληφθεί αρκετά σημεία δεδομένων για την δημιουργία της αναφοράς, Παρακαλώ προσπαθήστε αργότερα.",
    "DOWNLOAD_AGENT_REPORTS": "Κατέβασμα αναφορών πράκτορα",
    "FILTER_DROPDOWN_LABEL": "Επιλογή πράκτορα",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Συζητήσεις",
        "DESC": "(Σύνολο)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Εισερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Εξερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Χρόνος πρώτης ανταπόκρισης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο πρώτος χρόνος απόκρισης είναι {metricValue} (βάσει {conversationCount} συνομιλίων)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Χρόνος ανάλυσης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο Χρόνος Ανάλυσης είναι {metricValue} (βασίζεται στις {conversationCount} συνομιλίες)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Αριθμός Αναλύσεων",
        "DESC": "(Σύνολο)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Τελευταίες 7 ημέρες"
      },
      {
        "id": 1,
        "name": "Τελευταίες 30 ημέρες"
      },
      {
        "id": 2,
        "name": "Τελευταίοι 3 μήνες"
      },
      {
        "id": 3,
        "name": "Τελευταίοι 6 μήνες"
      },
      {
        "id": 4,
        "name": "Τελευταίο έτος"
      },
      {
        "id": 5,
        "name": "Προσαρμοσμένο εύρος ημερομηνιών"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Εφαρμογή",
      "PLACEHOLDER": "Επιλέξτε εύρος ημερομηνιών"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Επισκόπηση Ετικετών",
    "DESCRIPTION": "Παρακολουθήστε την απόδοση των ετικετών με βασικές μετρήσεις, όπως συνομιλίες, χρόνους απόκρισης, χρόνους επίλυσης και επιλυμένες υποθέσεις.",
    "LOADING_CHART": "Φόρτωση δεδομένων γραφήματος...",
    "NO_ENOUGH_DATA": "Δεν έχουν ληφθεί αρκετά σημεία δεδομένων για την δημιουργία της αναφοράς, Παρακαλώ προσπαθήστε αργότερα.",
    "DOWNLOAD_LABEL_REPORTS": "Λήψη αναφορών ετικέτας",
    "FILTER_DROPDOWN_LABEL": "Επιλογή Ετικέτας",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Συζητήσεις",
        "DESC": "(Σύνολο)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Εισερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Εξερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Χρόνος πρώτης ανταπόκρισης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο πρώτος χρόνος απόκρισης είναι {metricValue} (βάσει {conversationCount} συνομιλίων)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Χρόνος ανάλυσης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο Χρόνος Ανάλυσης είναι {metricValue} (βασίζεται στις {conversationCount} συνομιλίες)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Αριθμός Αναλύσεων",
        "DESC": "(Σύνολο)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Τελευταίες 7 ημέρες"
      },
      {
        "id": 1,
        "name": "Τελευταίες 30 ημέρες"
      },
      {
        "id": 2,
        "name": "Τελευταίοι 3 μήνες"
      },
      {
        "id": 3,
        "name": "Τελευταίοι 6 μήνες"
      },
      {
        "id": 4,
        "name": "Τελευταίο έτος"
      },
      {
        "id": 5,
        "name": "Προσαρμοσμένο εύρος ημερομηνιών"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Εφαρμογή",
      "PLACEHOLDER": "Επιλέξτε εύρος ημερομηνιών"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Επισκόπηση Εισερχομένων",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Φόρτωση δεδομένων γραφήματος...",
    "NO_ENOUGH_DATA": "Δεν έχουν ληφθεί αρκετά σημεία δεδομένων για την δημιουργία της αναφοράς, Παρακαλώ προσπαθήστε αργότερα.",
    "DOWNLOAD_INBOX_REPORTS": "Λήψη αναφορών εισερχομένων",
    "FILTER_DROPDOWN_LABEL": "Επιλογή Εισερχομένων",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Συζητήσεις",
        "DESC": "(Σύνολο)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Εισερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Εξερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Χρόνος πρώτης ανταπόκρισης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο πρώτος χρόνος απόκρισης είναι {metricValue} (βάσει {conversationCount} συνομιλίων)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Χρόνος ανάλυσης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο Χρόνος Ανάλυσης είναι {metricValue} (βασίζεται στις {conversationCount} συνομιλίες)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Αριθμός Αναλύσεων",
        "DESC": "(Σύνολο)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Τελευταίες 7 ημέρες"
      },
      {
        "id": 1,
        "name": "Τελευταίες 30 ημέρες"
      },
      {
        "id": 2,
        "name": "Τελευταίοι 3 μήνες"
      },
      {
        "id": 3,
        "name": "Τελευταίοι 6 μήνες"
      },
      {
        "id": 4,
        "name": "Τελευταίο έτος"
      },
      {
        "id": 5,
        "name": "Προσαρμοσμένο εύρος ημερομηνιών"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Εφαρμογή",
      "PLACEHOLDER": "Επιλέξτε εύρος ημερομηνιών"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Επισκόπηση Ομάδας",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Φόρτωση δεδομένων γραφήματος...",
    "NO_ENOUGH_DATA": "Δεν έχουν ληφθεί αρκετά σημεία δεδομένων για την δημιουργία της αναφοράς, Παρακαλώ προσπαθήστε αργότερα.",
    "DOWNLOAD_TEAM_REPORTS": "Λήψη αναφορών ομάδας",
    "FILTER_DROPDOWN_LABEL": "Επιλογή Ομάδας",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Συζητήσεις",
        "DESC": "(Σύνολο)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Εισερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Εξερχόμενα Μηνύματα",
        "DESC": "(Σύνολο)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Χρόνος πρώτης ανταπόκρισης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο πρώτος χρόνος απόκρισης είναι {metricValue} (βάσει {conversationCount} συνομιλίων)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Χρόνος ανάλυσης",
        "DESC": "(Μ.Ο.)",
        "INFO_TEXT": "Συνολικός αριθμός συνομιλιών που χρησιμοποιήθηκαν για τον υπολογισμό:",
        "TOOLTIP_TEXT": "Ο Χρόνος Ανάλυσης είναι {metricValue} (βασίζεται στις {conversationCount} συνομιλίες)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Αριθμός Αναλύσεων",
        "DESC": "(Σύνολο)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Τελευταίες 7 ημέρες"
      },
      {
        "id": 1,
        "name": "Τελευταίες 30 ημέρες"
      },
      {
        "id": 2,
        "name": "Τελευταίοι 3 μήνες"
      },
      {
        "id": 3,
        "name": "Τελευταίοι 6 μήνες"
      },
      {
        "id": 4,
        "name": "Τελευταίο έτος"
      },
      {
        "id": 5,
        "name": "Προσαρμοσμένο εύρος ημερομηνιών"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Εφαρμογή",
      "PLACEHOLDER": "Επιλέξτε εύρος ημερομηνιών"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Αναφορές CSAT",
    "NO_RECORDS": "Δεν υπάρχουν διαθέσιμες απαντήσεις ερευνών CSAT.",
    "DOWNLOAD": "Λήψη αναφορών CSAT",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Επιλέξτε Πράκτορες"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Επαφές",
        "AGENT_NAME": "Αντιστοιχισμένος πράκτορας",
        "RATING": "Αξιολόγηση",
        "FEEDBACK_TEXT": "Σχόλιο ανατροφοδότησης"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Συνολικές απαντήσεις",
        "TOOLTIP": "Συνολικός αριθμός απαντήσεων"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Βαθμός ικανοποίησης",
        "TOOLTIP": "Συνολικός αριθμός θετικών αποκρίσεων / Συνολικός αριθμός ανταποκρίσεων * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Ποσοστό ανταπόκρισης",
        "TOOLTIP": "Συνολικός αριθμός απαντήσεων / Συνολικός αριθμός μηνυμάτων έρευνας CSAT * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Αριθμός Συζητήσεων",
        "TOOLTIP": "Συνολικός αριθμός συζητήσεων με μηνύματα bot"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Αριθμός Απαντήσεων",
        "TOOLTIP": "Συνολικός αριθμός εξερχόμενων μηνυμάτων"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Αριθμός Απαντήσεων AI",
        "TOOLTIP": "Συνολικός αριθμός μηνυμάτων απάντησης που στάλθηκαν από το bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Αριθμός Προετοιμασμένων Απαντήσεων",
        "TOOLTIP": "Συνολικός αριθμός προτάσεων copilot που προετοιμάστηκαν από το bot για τους πράκτορες"
      },
      "SUCCESS_RATE": {
        "LABEL": "Επιλύθηκαν από AI",
        "TOOLTIP": "Ποσοστό συζητήσεων που επιλύθηκαν από AI χωρίς παράδοση σε πράκτορα"
      },
      "RESOLVE_TIME": {
        "LABEL": "Χρόνος Επίλυσης",
        "TOOLTIP": "Διάμεσος χρόνος από το πρώτο μήνυμα του πελάτη έως το τελευταίο μήνυμα του bot/πράκτορα"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Χωρίς ομαδοποίηση",
      "INBOXES": "Εισερχόμενα",
      "LABELS": "Ετικέτες"
    },
    "GROUPED": {
      "CHART_TITLE": "Κατανομή κατά ομάδα",
      "BACK_TO_ALL": "Εμφάνιση όλων",
      "TABLE": {
        "INBOX": "Κιβώτιο εισερχομένων",
        "LABEL": "Ετικέτα",
        "CONVERSATIONS": "Συζητήσεις",
        "MESSAGES": "Μηνύματα",
        "MESSAGES_TOOLTIP": "Συνολικός αριθμός εξερχόμενων μηνυμάτων",
        "AI_MESSAGES": "Απαντήσεις AI",
        "AI_MESSAGES_TOOLTIP": "Συνολικός αριθμός απαντήσεων AI, ακολουθούμενος από τον αριθμό θετικών και αρνητικών αξιολογήσεων από τους τελικούς χρήστες",
        "THUMBS_UP_TOOLTIP": "Αριθμός απαντήσεων AI που αξιολογήθηκαν θετικά (thumbs up) από τους τελικούς χρήστες",
        "THUMBS_DOWN_TOOLTIP": "Αριθμός απαντήσεων AI που αξιολογήθηκαν αρνητικά (thumbs down) από τους τελικούς χρήστες",
        "PREPARED": "Προετοιμασμένες Απαντήσεις",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Ποσοστό μηνυμάτων από όλα τα μηνύματα που ανήκουν σε αυτή την ομάδα",
        "BOT_RESPONSES": "Απαντήσεις AI %",
        "SUGGESTION_USED": "Χρησιμοποιημένες Απαντήσεις",
        "SUGGESTION_USED_TOOLTIP": "Ποσοστό προετοιμασμένων απαντήσεων σε αυτή την ομάδα που χρησιμοποιήθηκαν από πράκτορες",
        "SUGGESTION_NOT_USED": "Αχρησιμοποίητες Απαντήσεις",
        "SUGGESTION_NOT_USED_TOOLTIP": "Ποσοστό μηνυμάτων σε αυτή την ομάδα που είχαν προετοιμασμένη απάντηση, αλλά δεν χρησιμοποιήθηκε"
      },
      "NOTES": {
        "TITLE": "Πώς υπολογίζονται οι μετρήσεις",
        "CONVERSATIONS": "Αριθμός συζητήσεων που έχουν τουλάχιστον ένα εξερχόμενο μήνυμα στην επιλεγμένη περίοδο.",
        "MESSAGES": "Συνολικός αριθμός εξερχόμενων (μη ιδιωτικών) μηνυμάτων που στάλθηκαν στην επιλεγμένη περίοδο. Περιλαμβάνει τόσο μηνύματα που δημιουργήθηκαν από AI όσο και μηνύματα γραμμένα από ανθρώπους.",
        "PERCENTAGE": "Ποσοστό των μηνυμάτων αυτής της ομάδας από το σύνολο των εξερχόμενων μηνυμάτων σε όλες τις ομάδες.",
        "AI_MESSAGES": "Αριθμός εξερχόμενων μηνυμάτων που στάλθηκαν αυτόματα από το bot AI (χωρίς να περιλαμβάνονται οι προετοιμασμένες απαντήσεις για πράκτορες). Οι αριθμοί σε παρένθεση δείχνουν πόσες από αυτές τις απαντήσεις αξιολογήθηκαν θετικά (thumbs up) και αρνητικά (thumbs down) από τους τελικούς χρήστες.",
        "PREPARED": "Αριθμός προτάσεων copilot (προετοιμασμένων απαντήσεων) που δημιουργήθηκαν από το bot AI για τους πράκτορες στην επιλεγμένη περίοδο. Πρόκειται για ιδιωτικά μηνύματα ορατά μόνο στους πράκτορες και δεν προσμετρώνται ως εξερχόμενα μηνύματα, οπότε αυτός ο αριθμός ενδέχεται να μην συσχετίζεται με τη στήλη Μηνύματα.",
        "SUGGESTION_USED": "Ποσοστό προετοιμασμένων απαντήσεων σε αυτή την ομάδα που χρησιμοποιήθηκαν από πράκτορες. Ενδέχεται να μην συσχετίζεται με τον αριθμό Προετοιμασμένων Απαντήσεων, καθώς μπορεί να περιλαμβάνει και προτάσεις που δημιουργήθηκαν σε προηγούμενες περιόδους.",
        "SUGGESTION_NOT_USED": "Ποσοστό εξερχόμενων μηνυμάτων σε αυτή την ομάδα όπου υπήρχε διαθέσιμη πρόταση copilot, αλλά ο πράκτορας απάντησε χωρίς να τη χρησιμοποιήσει. Υπολογίζεται μόνο όταν ο πράκτορας έστειλε πράγματι απάντηση. Ενδέχεται να μην συσχετίζεται με τον αριθμό Προετοιμασμένων Απαντήσεων, καθώς μπορεί να περιλαμβάνει και προτάσεις που δημιουργήθηκαν σε προηγούμενες περιόδους."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Επισκόπηση",
    "LIVE": "Ζωντανά",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Άνοιγμα συνομιλιών",
      "LOADING_MESSAGE": "Φόρτωση μετρητών συνομιλίας...",
      "OPEN": "Άνοιγμα",
      "UNATTENDED": "Χωρίς Παρακολούθηση",
      "UNASSIGNED": "Χωρίς Αντιστοίχιση",
      "PENDING": "Εκκρεμεί"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Συζητήσεις αντιπροσώπων",
      "LOADING_MESSAGE": "Φόρτωση μετρήσεων πράκτορα...",
      "NO_AGENTS": "Δεν υπάρχουν συνομιλίες από πράκτορες",
      "TABLE_HEADER": {
        "AGENT": "Πράκτορας",
        "OPEN": "Ανοιχτές",
        "UNATTENDED": "Χωρίς Παρακολούθηση",
        "STATUS": "Κατάσταση"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Ομάδα",
        "OPEN": "Ανοιχτές",
        "UNATTENDED": "Χωρίς Παρακολούθηση",
        "STATUS": "Κατάσταση"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Κατάσταση πράκτορα",
      "ONLINE": "Στην Γραμμή",
      "BUSY": "Απασχολημένος",
      "OFFLINE": "Εκτός"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Δεν βρέθηκαν αποτελέσματα",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Όνομα Πράκτορα",
        "INBOXES": "Όνομα Κιβωτίου",
        "LABELS": "Όνομα ετικέτας",
        "TEAMS": "Όνομα ομάδας"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Εισερχόμενα",
      "AGENTS": "Πράκτορας",
      "LABELS": "Ετικέτα",
      "TEAMS": "Ομάδα"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Συνομιλία",
        "AGENT": "Πράκτορας"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Μερικό σύνολο",
    "NO_TEAM": "Χωρίς ομάδα",
    "GROUP_BY_TEAMS": "Ομαδοποίηση κατά ομάδες",
    "INBOX": "Εισερχόμενα",
    "AGENT": "Πράκτορας",
    "TEAM": "Ομάδα",
    "LABEL": "Ετικέτα",
    "TOTAL": "Σύνολο",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Αριθμός Αναλύσεων",
    "CONVERSATIONS": "Αριθμός συνομιλιών",
    "OUTGOING_CHATS": "Εξερχόμενα chat",
    "OUTGOING_EMAILS": "Εξερχόμενα email",
    "PHONE_CALLS": "Τηλεφωνικές κλήσεις",
    "INBOUND_CALLS": "Εισερχόμενες κλήσεις",
    "OUTBOUND_CALLS": "Εξερχόμενες κλήσεις",
    "TOTAL_ACTIVITIES": "Συνολικές δραστηριότητες",
    "ONLINE_TIME": "Χρόνος σύνδεσης",
    "QUEUE_AVAILABLE_TIME": "Χρόνος διαθεσιμότητας σε ουρά",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Αριθμός εξερχόμενων μηνυμάτων που στάλθηκαν από αυτόν τον πράκτορα",
      "OUTGOING_EMAILS": "Αριθμός εξερχόμενων email που στάλθηκαν από αυτόν τον πράκτορα",
      "PHONE_CALLS": "Συνολικός αριθμός τηλεφωνικών κλήσεων που ανατέθηκαν σε αυτόν τον πράκτορα (άθροισμα εισερχόμενων και εξερχόμενων κλήσεων)",
      "TOTAL_ACTIVITIES": "Συνολικός αριθμός δραστηριοτήτων: εισερχόμενες κλήσεις + εξερχόμενες κλήσεις + εξερχόμενα chat + εξερχόμενα email",
      "INBOUND_CALLS": "Αριθμός εισερχόμενων τηλεφωνικών κλήσεων που ανατέθηκαν σε αυτόν τον πράκτορα",
      "OUTBOUND_CALLS": "Αριθμός εξερχόμενων τηλεφωνικών κλήσεων που ανατέθηκαν σε αυτόν τον πράκτορα",
      "AVG_FIRST_RESPONSE_TIME": "Μέσος χρόνος από τη δημιουργία της συνομιλίας έως την πρώτη απάντηση πράκτορα, στις συνομιλίες που έχουν ανατεθεί σε αυτόν τον πράκτορα",
      "AVG_RESOLUTION_TIME": "Μέσος χρόνος από τη δημιουργία της συνομιλίας έως την επίλυση, στις συνομιλίες που έχουν ανατεθεί σε αυτόν τον πράκτορα",
      "AVG_REPLY_TIME": "Μέσος χρόνος αναμονής των πελατών ανάμεσα στο μήνυμά τους και την απάντηση του πράκτορα, στις συνομιλίες που έχουν ανατεθεί σε αυτόν τον πράκτορα",
      "ONLINE_TIME": "Συνολικός χρόνος που ο πράκτορας ήταν συνδεδεμένος ή απασχολημένος κατά την επιλεγμένη περίοδο",
      "QUEUE_AVAILABLE_TIME": "Συνολικός χρόνος που ο πράκτορας ήταν διαθέσιμος σε ουρές τηλεφώνου κατά την επιλεγμένη περίοδο"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Αναφορές Τηλεφώνου",
    "DESCRIPTION": "Παρακολουθήστε μετρήσεις τηλεφωνικών κλήσεων με λεπτομερή στοιχεία για εισερχόμενες και εξερχόμενες κλήσεις, ομαδοποιημένες κατά πράκτορα ή κιβώτιο εισερχομένων για ολοκληρωμένη ανάλυση.",
    "DOWNLOAD_PHONE_REPORTS": "Λήψη Αναφορών Τηλεφώνου",
    "GROUP_BY": {
      "LABEL": "Ομαδοποίηση Κατά",
      "AGENT": "Πράκτορας",
      "INBOX": "Κιβώτιο εισερχομένων"
    },
    "TABLE": {
      "TOTAL_CALLS": "Σύνολο",
      "INBOUND_CALLS": "Εισερχόμενες",
      "OUTBOUND_CALLS": "Εξερχόμενες",
      "FAILED_OUTBOUND_CALLS": "Αποτυχημένες εξερχόμενες",
      "AVG_AGENT_HANDLED_DURATION": "Μέση Διάρκεια",
      "TOTAL_AGENT_HANDLED_DURATION": "Συνολική Διάρκεια",
      "AVG_RINGING_TIME": "Μέσος Χρόνος Κουδουνίσματος",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Επιτυχία %",
      "UNIQUE_CALLERS": "Μοναδικοί Καλούντες",
      "UNIQUE_CALLED_CONTACTS": "Μοναδικοί Κληθέντες",
      "UNANSWERED_MISSED_CALLS": "Αναπάντητες χωρίς παρακολούθηση",
      "UNANSWERED_MISSED_PERCENTAGE": "Αναπάντητες χωρίς παρακολούθηση %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Αναπάντητες χωρίς παρακολούθηση, ανεπαρκώς επανακληθείσες",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Αναπάντητες χωρίς παρακολούθηση, ανεπαρκώς επανακληθείσες %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Συνολικός αριθμός όλων των κλήσεων (συμπεριλαμβανομένων των μη συνδεδεμένων)",
      "INBOUND_CALLS": "Αριθμός συνδεδεμένων κλήσεων",
      "OUTBOUND_CALLS": "Αριθμός όλων των εξερχόμενων κλήσεων (συμπεριλαμβανομένων των μη συνδεδεμένων)",
      "FAILED_OUTBOUND_CALLS": "Αριθμός εξερχόμενων κλήσεων που απέτυχαν να συνδεθούν",
      "AVG_AGENT_HANDLED_DURATION": "Μέση διάρκεια κλήσεων που εξυπηρετήθηκαν από πράκτορες",
      "TOTAL_AGENT_HANDLED_DURATION": "Συνολική διάρκεια όλων των κλήσεων που εξυπηρετήθηκαν από πράκτορες",
      "AVG_RINGING_TIME": "Μέσος χρόνος που οι κλήσεις κουδούνιζαν πριν απαντηθούν",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Ποσοστό εξερχόμενων κλήσεων που συνδέθηκαν με επιτυχία",
      "UNIQUE_CALLERS": "Αριθμός μοναδικών επαφών που πραγματοποίησαν εισερχόμενες κλήσεις",
      "UNIQUE_CALLED_CONTACTS": "Αριθμός μοναδικών επαφών που κλήθηκαν μέσω εξερχόμενων κλήσεων",
      "UNANSWERED_MISSED_CALLS": "Αριθμός αναπάντητων κλήσεων όπου δεν έγινε επιτυχής επανάκληση (κλήση που συνδέθηκε). Ενδέχεται να περιλαμβάνει κλήσεις που μπορούν ακόμη να εξυπηρετηθούν εντός της εργάσιμης ημέρας",
      "UNANSWERED_MISSED_PERCENTAGE": "Ποσοστό μοναδικών καλούντων των οποίων οι κλήσεις έμειναν αναπάντητες χωρίς παρακολούθηση (αναπάντητες κλήσεις χωρίς παρακολούθηση / μοναδικοί καλούντες)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Αριθμός αναπάντητων κλήσεων με λιγότερες από 2 προσπάθειες επανάκλησης. Ενδέχεται να περιλαμβάνει κλήσεις που μπορούν ακόμη να εξυπηρετηθούν εντός της εργάσιμης ημέρας",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Ποσοστό μοναδικών καλούντων με λιγότερες από 2 προσπάθειες επανάκλησης ((αναπάντητες χωρίς παρακολούθηση - επαρκώς εξυπηρετημένες) / μοναδικοί καλούντες)"
    }
  }
}
